import React from "react";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";

const CheckboxView = (props) => {
  return (
    <FormControlLabel
      control={
        <Checkbox testid="check" checked={props.checked} onChange={(e) => props.onCheck(e)} />
      }
      label={props.label}
    />
  );
};

export default CheckboxView;
